<section class="recuperacion">
	<div class="recuperacion-header fondo-blue"></div>
	<section class="recuperacion-form">
		<div class="recuperacion-form-image">
			<img src="assets/images/logo-big.png" loading="lazy" alt="Pawerful PetShop"/>
		</div>
		<div class="recuperacion-form-titulo">
			<h2>Recuperación de contraseña</h2>
		</div>
		<div class="recuperacion-form-titulo">
			<h3 class="color-purple">Selecciona una opción de recuperación</h3>
		</div>
		<div class="recuperacion-form-opcion">
			<div (click)=" fnCambiarOpcion( true ) ">
				<img src="assets/images/recuperacion/correo.png" alt="Correo" loading="lazy" />
			</div>
			<div (click)=" fnCambiarOpcion( false ) ">
				<img src="assets/images/recuperacion/sms.png" alt="SMS" loading="lazy"/>
			</div>
		</div>
		<div class="recuperacion-form-content" *ngIf=" esEmail ">
			<h4 class="color-blue">Mandaremos un email a la cuenta de correo electrónico con la que te registraste</h4>
			<input [(ngModel)]="correo" type="text" placeholder="Ingresa tu correo electrónico">
			<div class="recuperacion-form-content-controls">
				<button (click)="fnEnviarSolicitud()" class="recuperacion-form-content-button fondo-blue">
					Envíar Correo
				</button>
			</div>
		</div>
		<div class="recuperacion-form-content" *ngIf=" !esEmail ">
			<h4 class="color-green">Mandaremos un mensaje de texto al número telefónico con el que te registraste</h4>
			<div class="control" [@tgTelefono]="estiloTelefono">
				<input type="text" class="telInput" 
					ng2TelInput
					[ng2TelInputOptions]="{initialCountry: 'in'}"
					(hasError)="hasError($event)"
					(ng2TelOutput)="getNumber($event)"
					(intlTelInputObject)="telInputObject($event)"
					(countryChange)="onCountryChange($event)" />
			</div>
			<div class="recuperacion-form-content-controls">
				<button (click)="fnEnviarSolicitud()" class="recuperacion-form-content-button fondo-green">
					Envíar SMS
				</button>
			</div>
		</div>
		<section>
			<p>
				<a [routerLink]="[ '/acceso' ]"><b class="color-blue">¡Tengo mis datos de acceso!</b></a>
			</p>
		</section>
	</section>
</section>